import { CreateLocationProps, TeachingLocation } from 'types/location'
import { authorizedRequest } from '..'

export const createLocation = async (
  locationData: CreateLocationProps
): Promise<TeachingLocation> => {
  try {
    const response = await authorizedRequest({
      endpoint: `location`,
      method: 'POST',
      body: locationData,
    })
    const { location } = (await response.json()) as {
      success: true
      location: TeachingLocation
    }
    return location
  } catch (e: any) {
    throw e
  }
}
